export const insightMapping: Record<string, string> = {
  PBS: 'MA2',
  MBS: 'AA2',
};
